import React, { useEffect, useState, useCallback } from "react";
import {
  Button,
  Box,
  Paper,
  Grid,
  styled,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from "@mui/material";
import { tableCellClasses } from "@mui/material/TableCell";
import { CustomDownloadLoader } from "../../Components/CustomDownloadLoader";
import { CustomPagination } from "../../Components/CustomPagination";
import { CustomLoader } from "../../Components/CustomLoader";
import ProductForecastService from "../../services/ProductForecastService";
import { Popup } from "../../Components/Popup";
import { ForecastUpdate } from "../Cutomers/ForecastDetails/ForecastUpdate";
import { ProductForecastAssignTo } from "./ProductForecastAssignTo";
import { Helmet } from "react-helmet";
import { useSelector } from "react-redux";
import CustomAutocomplete from "../../Components/CustomAutocomplete";
import { useNotificationHandling } from "../../Components/useNotificationHandling ";
import { MessageAlert } from "../../Components/MessageAlert";
import SearchComponent from "../../Components/SearchComponent ";

export const CustomerNotHavingForecastView = () => {
  const [open, setOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [salesPersonByFilter, setSalesPersonByFilter] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [customerNotHavingForecast, setCustomerNotHavingForecast] = useState(
    [],
  );
  const [downloadProgress, setDownloadProgress] = useState(0);
  const [downloadedMB, setDownloadedMB] = useState(0);
  const [totalMB, setTotalMB] = useState(0);
  const [isDisabled, setIsDisabled] = useState(false);
  const [countdown, setCountdown] = useState(0);
  const [forecastDataByID, setForecastDataByID] = useState(null);
  const [openPopup, setOpenPopup] = useState(false);
  const [openPopup2, setOpenPopup2] = useState(false);
  const [DownloadOpen, setDownloadOpen] = useState(false);

  const [isPrinting, setIsPrinting] = useState(false);
  const UserData = useSelector((state) => state.auth.profile);
  const assignedOption = UserData.sales_customer_user_forecast || [];
  console.log("Assigned option is :", assignedOption);
  const { handleSuccess, handleError, handleCloseSnackbar, alertInfo } =
    useNotificationHandling();

  const currentDate = new Date();
  const currentMonth = currentDate.getMonth();
  const currentYear = currentDate.getFullYear();

  // Define the months array
  const months = [
    "Jan",
    "Feb",
    "March",
    "April",
    "May",
    "June",
    "July",
    "Aug",
    "Sept",
    "Oct",
    "Nov",
    "Dec",
  ];

  // HELPER FUNCTION: Calculate month and year for offset
  const getMonthYear = (monthOffset) => {
    const targetMonth = currentMonth + monthOffset;
    const monthIndex = ((targetMonth % 12) + 12) % 12;
    const yearOffset = Math.floor(targetMonth / 12);
    const year = currentYear + yearOffset;
    return { monthIndex, year };
  };

  // Calculate the previous and next months with correct years
  const lastMonth1Data = getMonthYear(-2);
  const lastMonth2Data = getMonthYear(-1);
  const currentMonthData = getMonthYear(0);
  const nextMonth1Data = getMonthYear(1);
  const nextMonth2Data = getMonthYear(2);
  const nextMonth3Data = getMonthYear(3);

  // Restore countdown from localStorage on page refresh
  useEffect(() => {
    const savedEndTime = localStorage.getItem("csvDownloadEndTime");
    if (savedEndTime) {
      const remaining = Math.floor(
        (parseInt(savedEndTime) - Date.now()) / 1000,
      );
      if (remaining > 0) {
        setIsDisabled(true);
        setCountdown(remaining);
      } else {
        localStorage.removeItem("csvDownloadEndTime");
      }
    }
  }, []);

  // Run countdown interval whenever isDisabled becomes true
  useEffect(() => {
    if (!isDisabled) return;
    const interval = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          setIsDisabled(false);
          localStorage.removeItem("csvDownloadEndTime");
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, [isDisabled]);

  useEffect(() => {
    const beforePrint = () => {
      setIsPrinting(true);
      setCustomerNotHavingForecast([]);
    };

    const afterPrint = () => {
      setIsPrinting(false);
      getAllCustomerNotHavingForecastDetails();
    };

    window.addEventListener("beforeprint", beforePrint);
    window.addEventListener("afterprint", afterPrint);

    return () => {
      window.removeEventListener("beforeprint", beforePrint);
      window.removeEventListener("afterprint", afterPrint);
    };
  }, []);

  const handleDownload = async () => {
    try {
      setDownloadOpen(true);
      setIsDisabled(true);
      setDownloadProgress(0);
      setDownloadedMB(0);
      setTotalMB(0);

      const response =
        await ProductForecastService.downloadCustomerNotHavingData("csv", {
          responseType: "blob",
          onDownloadProgress: (event) => {
            const loaded = (event.loaded / 1024 / 1024).toFixed(2);
            setDownloadedMB(loaded);
            if (event.total) {
              const total = (event.total / 1024 / 1024).toFixed(2);
              const percent = Math.round((event.loaded / event.total) * 100);
              setTotalMB(total);
              setDownloadProgress(percent);
            }
          },
        });
      console.log(response.data);

      // Trigger file download
      const blob = new Blob([response.data], {
        type: "text/csv;charset=utf-8;",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "customer_not_having_forecast.csv";
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      handleSuccess("CSV downloaded successfully");

      // Start 30-min cooldown
      const endTime = Date.now() + 900 * 1000;
      localStorage.setItem("csvDownloadEndTime", endTime.toString());
      setCountdown(900);
      setIsDisabled(true);
    } catch (error) {
      handleError(error);
      setIsDisabled(false);
      console.error("CSV Download error", error);
    } finally {
      setDownloadOpen(false);
      setDownloadProgress(0);
    }
  };
  const getAllCustomerNotHavingForecastDetails = useCallback(async () => {
    try {
      setOpen(true);
      const response = await ProductForecastService.getAllCustomerNotHavingData(
        currentPage,
        salesPersonByFilter,
        searchQuery,
      );
      setCustomerNotHavingForecast(response.data.results);
      const total = response.data.count;
      setTotalPages(Math.ceil(total / 25));
    } catch (error) {
      handleError(error);
      console.error("Error fetching Customer Having Forecast", error);
    } finally {
      setOpen(false);
    }
  }, [currentPage, salesPersonByFilter, searchQuery]);

  useEffect(() => {
    getAllCustomerNotHavingForecastDetails();
  }, [currentPage, salesPersonByFilter, searchQuery]);

  const handleSearch = (query) => {
    setSearchQuery(query);
    setCurrentPage(1);
  };
  const isSupplyChain = UserData.groups.includes(
    "Operations & Supply Chain Manager",
  );
  const emails = [
    "admin@glutape.com",
    "rajeev@glutape.com",
    "gaurav@glutape.com",
    "arjun@glutape.com",
    "pruthvi@glutape.com",
    "anuradha@glutape.com",
    "vivek_production@glutape.com",
    "vivek2@glutape.com",
    "managerwithoutlead@glutape.com",
    "biraj@glutape.com",
    "rushilsalian13@glutape.com",
    "it1@glutape.com",
  ];

  const handleReset = () => {
    setSearchQuery("");
    setCurrentPage(1);
  };

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  const handleEditClick = useCallback(
    (item) => {
      const matchedForecast = customerNotHavingForecast.find(
        (forecast) => forecast.id === item.id,
      );
      setForecastDataByID(matchedForecast);
      setOpenPopup(true);
    },
    [customerNotHavingForecast],
  );

  const handleAssignTo = useCallback(
    (item) => {
      const matchedForecast = customerNotHavingForecast.find(
        (forecast) => forecast.id === item.id,
      );
      setForecastDataByID(matchedForecast);
      setOpenPopup2(true);
    },
    [customerNotHavingForecast],
  );

  const handleFilterChange = (value) => {
    setSalesPersonByFilter(value);
    // getAllCustomerNotHavingForecastDetails(currentPage, value, searchQuery);
  };

  // Get the unique index_position values to use as column headers
  const indexPositions = [
    ...new Set(
      customerNotHavingForecast &&
        customerNotHavingForecast.flatMap((row) =>
          row.product_forecast.map((rowData) => rowData.index_position),
        ),
    ),
  ];

  indexPositions.sort((a, b) => a - b);

  const formatToTwoDecimal = (value) => {
    return value !== null && value !== undefined
      ? Number(value).toFixed(2)
      : "N/A";
  };
  return (
    <div>
      <Helmet>
        <style>
          {`
            @media print {
              html, body {
                filter: ${isPrinting ? "blur(10px)" : "none"} !important;
              }
            }
          `}
        </style>
      </Helmet>
      <MessageAlert
        open={alertInfo.open}
        onClose={handleCloseSnackbar}
        severity={alertInfo.severity}
        message={alertInfo.message}
      />
      <CustomLoader open={open} />
      <CustomDownloadLoader
        open={DownloadOpen}
        downloadedMB={downloadedMB}
        totalMB={totalMB}
        downloadProgress={downloadProgress}
      />
      <Grid item xs={12}>
        <Paper sx={{ p: 2, m: 4, display: "flex", flexDirection: "column" }}>
          <Box sx={{ marginBottom: 2, display: "flex", alignItems: "center" }}>
            <Grid
              container
              spacing={2}
              alignItems="center"
              sx={{ marginRight: 5, marginLeft: 5 }}
            >
              {!UserData.groups.includes("Sales Executive") && (
                <Grid item xs={12} sm={3}>
                  <CustomAutocomplete
                    size="small"
                    sx={{ minWidth: 150 }}
                    onChange={(event, value) => handleFilterChange(value)}
                    value={salesPersonByFilter}
                    options={
                      isSupplyChain
                        ? emails
                        : assignedOption.length > 0 &&
                          assignedOption
                            .filter(
                              (option) =>
                                option.groups.includes("Sales Manager") || // option.groups === "Sales Manager" ||
                                option.groups.includes("Sales Executive") ||
                                option.groups.includes(
                                  "Sales Deputy Manager",
                                ) ||
                                option.groups.includes(
                                  "Sales Assistant Deputy Manager",
                                ) ||
                                option.groups.includes(
                                  "Sales Manager(Retailer)",
                                ) ||
                                option.groups.includes("Customer Service") || // option.groups === "Customer Service" ||
                                option.groups.includes("Director") ||
                                option.groups.includes(
                                  "Customer Relationship Executive",
                                ),
                            )
                            .map((option) => option.email)
                    }
                    getOptionLabel={(option) => option}
                    label="Filter By Sales Person"
                  />
                </Grid>
              )}
              <Grid item xs={12} sm={3}>
                <SearchComponent
                  onSearch={handleSearch}
                  onReset={handleReset}
                />
              </Grid>
              <Grid item xs={12} sm={2}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleDownload}
                  disabled={isDisabled}
                >
                  {downloadProgress > 0 && downloadProgress < 100
                    ? totalMB > 0
                      ? `Downloading... ${downloadedMB} MB / ${totalMB} MB (${downloadProgress}%)`
                      : `Downloading... ${downloadedMB} MB`
                    : isDisabled
                      ? `Download available in ${String(Math.floor(countdown / 60)).padStart(2, "0")}:${String(countdown % 60).padStart(2, "0")}`
                      : "Download CSV"}
                </Button>
              </Grid>
            </Grid>
          </Box>
          <Box display="flex" justifyContent="center" marginBottom="10px">
            <h3
              style={{
                marginBottom: "1em",
                fontSize: "24px",
                color: "rgb(34, 34, 34)",
                fontWeight: 800,
                textAlign: "center",
              }}
            >
              Customer Not Having Forecast
            </h3>
          </Box>
          <TableContainer
            sx={{
              maxHeight: 440,
              "&::-webkit-scrollbar": {
                width: 15,
              },
              "&::-webkit-scrollbar-track": {
                backgroundColor: "#f2f2f2",
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "#aaa9ac",
              },
            }}
          >
            <Table
              sx={{ minWidth: 700 }}
              stickyHeader
              aria-label="sticky table"
            >
              <TableHead>
                <StyledTableRow>
                  <StyledTableCell align="center">COMPANY</StyledTableCell>
                  <StyledTableCell align="center">SALES PERSON</StyledTableCell>
                  <StyledTableCell align="center">PRODUCT</StyledTableCell>
                  <StyledTableCell align="center">
                    {`${months[lastMonth1Data.monthIndex]} - ${lastMonth1Data.year}`}
                    <br />
                    ACTUAL
                  </StyledTableCell>
                  <StyledTableCell
                    align="center"
                    sx={{
                      minWidth: 80,
                      borderRight: "2px solid #fff !important",
                    }}
                  >
                    {`${months[lastMonth1Data.monthIndex]} - ${lastMonth1Data.year}`}
                    <br />
                    FORECAST
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    {`${months[lastMonth2Data.monthIndex]} - ${lastMonth2Data.year}`}
                    <br />
                    ACTUAL
                  </StyledTableCell>
                  <StyledTableCell
                    align="center"
                    sx={{
                      minWidth: 80,
                      borderRight: "2px solid #fff !important",
                    }}
                  >
                    {`${months[lastMonth2Data.monthIndex]} - ${lastMonth2Data.year}`}
                    <br />
                    FORECAST
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    {`${months[currentMonthData.monthIndex]} - ${currentMonthData.year}`}
                    <br />
                    ACTUAL
                  </StyledTableCell>
                  <StyledTableCell
                    align="center"
                    sx={{
                      minWidth: 80,
                      borderRight: "2px solid #fff !important",
                    }}
                  >
                    {`${months[currentMonthData.monthIndex]} - ${currentMonthData.year}`}
                    <br />
                    FORECAST
                  </StyledTableCell>
                  <StyledTableCell
                    align="center"
                    sx={{
                      minWidth: 80,
                      borderRight: "2px solid #fff !important",
                    }}
                  >
                    {`${months[nextMonth1Data.monthIndex]} - ${nextMonth1Data.year}`}
                    <br />
                    FORECAST
                  </StyledTableCell>
                  <StyledTableCell
                    align="center"
                    sx={{
                      minWidth: 80,
                      borderRight: "2px solid #fff !important",
                    }}
                  >
                    {`${months[nextMonth2Data.monthIndex]} - ${nextMonth2Data.year}`}
                    <br />
                    FORECAST
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    {`${months[nextMonth3Data.monthIndex]} - ${nextMonth3Data.year}`}
                    <br />
                    FORECAST
                  </StyledTableCell>
                  <StyledTableCell align="center">Action</StyledTableCell>
                </StyledTableRow>
              </TableHead>
              <TableBody>
                {customerNotHavingForecast &&
                  customerNotHavingForecast.map((row) => (
                    <StyledTableRow key={row.id}>
                      <StyledTableCell align="center">
                        {row.company}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {row.assign_to_email.join(", ")}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {row.product}
                      </StyledTableCell>
                      {indexPositions.map((position) => {
                        const rowData = row.product_forecast.find(
                          (data) => data.index_position === position,
                        );

                        if (position <= 2) {
                          return (
                            <React.Fragment key={position}>
                              <TableCell
                                align="center"
                                sx={{ padding: "6px 8px", fontSize: 14 }}
                              >
                                {rowData
                                  ? formatToTwoDecimal(rowData.actual)
                                  : "N/A"}
                              </TableCell>

                              <TableCell
                                align="center"
                                sx={{
                                  padding: "6px 8px",
                                  fontSize: 14,
                                  borderRight: "2px solid #ccc !important",
                                }}
                              >
                                {rowData
                                  ? formatToTwoDecimal(rowData.forecast)
                                  : "N/A"}
                              </TableCell>
                            </React.Fragment>
                          );
                        }

                        return (
                          <TableCell
                            key={`${position}-forecast`}
                            align="center"
                            sx={{
                              padding: "6px 8px",
                              fontSize: 14,
                              borderRight:
                                position < 5
                                  ? "2px solid #ccc !important"
                                  : "none",
                            }}
                          >
                            {rowData
                              ? formatToTwoDecimal(rowData.forecast)
                              : "N/A"}
                          </TableCell>
                        );
                      })}
                      <StyledTableCell align="center">
                        <Button
                          sx={{ color: "#1976d2" }}
                          onClick={() => handleEditClick(row)}
                        >
                          View
                        </Button>
                        <Button
                          sx={{ color: "#28a745" }}
                          onClick={() => handleAssignTo(row)}
                        >
                          Assign To
                        </Button>
                      </StyledTableCell>
                    </StyledTableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
          <CustomPagination
            totalPages={totalPages}
            currentPage={currentPage}
            handlePageChange={handlePageChange}
          />
        </Paper>
      </Grid>
      <Popup
        title={"Update Forecast Details"}
        openPopup={openPopup}
        setOpenPopup={setOpenPopup}
      >
        <ForecastUpdate
          getAllCompanyDetailsByID={getAllCustomerNotHavingForecastDetails}
          setOpenPopup={setOpenPopup}
          forecastDataByID={forecastDataByID}
        />
      </Popup>
      <Popup
        title={"Product Forecast Assign To"}
        openPopup={openPopup2}
        setOpenPopup={setOpenPopup2}
      >
        <ProductForecastAssignTo
          getAllCompanyDetailsByID={getAllCustomerNotHavingForecastDetails}
          setOpenPopup2={setOpenPopup2}
          forecastDataByID={forecastDataByID}
        />
      </Popup>
    </div>
  );
};

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    padding: "8px 6px", // 👈 was 0
    fontSize: 12,
    fontWeight: "bold",
    lineHeight: 1.4,
    whiteSpace: "nowrap",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    padding: "6px 8px", // 👈 was 0
    whiteSpace: "nowrap",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));
